import React, { forwardRef, useEffect } from "react";

interface BannerNotificationProps {
  message: React.ReactNode;
  isOpen: boolean;
  color?: "cyan" | "amber" | "red" | "redish"; // added optional color prop
}

const BannerNotification = forwardRef<HTMLDivElement, BannerNotificationProps>(
  ({ message, isOpen, color = "cyan" }, ref) => {
    useEffect(() => {
      if (isOpen) {
        document.body.style.paddingTop = "33px";
      }
      return () => {
        document.body.style.paddingTop = "";
      };
    }, [isOpen]);

    const baseClasses = [
      "w-full",
      "box-border",
      "transform",
      "-translate-y-full",
      "text-white",
      "font-sans",
      "text-sm", // smaller text size
      "py-1", // reduced vertical padding
      color === "cyan"
        ? "bg-highlight dark:bg-cyan-700"
        : color === "amber"
          ? "bg-amber-500 dark:bg-amber-500"
          : color === "redish"
            ? "bg-[#BD5421] dark:bg-[#BD5421]"
            : "bg-red-500 dark:bg-red-700",
      "transition-transform",
      "duration-800",
      "ease-out",
    ];

    if (isOpen) {
      baseClasses.push("translate-y-0");
    }

    return (
      <div ref={ref} className={baseClasses.join(" ")}>
        <div className="text-center">{message}</div>
      </div>
    );
  }
);

BannerNotification.displayName = "BannerNotification";

export default BannerNotification;
